/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { useEffect, useState } from 'react';
import { IMoeSensitivecontentBannerViewProps } from './moe-sensitivecontent-banner';
import { IS_LOCAL_DEVELOPMENT } from '../../utilities/language-change';
import MsDyn365 from '@msdyn365-commerce/core';

export default (props: IMoeSensitivecontentBannerViewProps) => {
    const { config } = props;
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        if (MsDyn365.isBrowser && !IS_LOCAL_DEVELOPMENT) {
            const timer = localStorage.getItem(`moeSensitiveBannerTimer`);
            if (timer) {
                const ttlHours: number = config.hoursForTTL || 24;
                const setupTime: number = JSON.parse(timer);
                const now: number = new Date().getTime();

                if (now - setupTime > ttlHours * 60 * 60 * 1000) {
                    setShowBanner(true);
                }
            } else {
                setShowBanner(true);
            }
        }
    }, []);

    const closeSensitiveInfoBanner = () => {
        if (IS_LOCAL_DEVELOPMENT) {
            return;
        }
        if (MsDyn365.isBrowser) {
            localStorage.setItem(`moeSensitiveBannerTimer`, JSON.stringify(new Date().getTime()));
            setShowBanner(false);
        }
    };

    return (
        showBanner && (
            <div className='moe-sensitivebnr'>
                <div className='moe-sensitivebnr__container msc-alert'>
                    <div className='moe-sensitivebnr__content'>
                        <div className='moe-sensitivebnr__text'>
                            <p>{config.maoriContent}</p>
                            <p>{config.englishContent}</p>
                        </div>
                    </div>
                    <div className='moe-sensitivebnr__btn'>
                        <button onClick={closeSensitiveInfoBanner}>{config.buttonText}</button>
                    </div>
                </div>
            </div>
        )
    );
};
